import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import CountryOptionsPanel from "./CountryOptionsPanel";
import { CountryDetailSection } from "./CountryDetailSection";
import { VatRatesPanel } from "bookkeeping/VatRatesPanel";
import { useLoaderData } from "react-router";

const CountryDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.CountryDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <CountryDetailSection
        viewModel={viewModel}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <CountryOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
      />
      <VatRatesPanel country={viewModel.country.key} />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default CountryDetailApp;